import { Grid, Box, Typography } from "@mui/material";

const SignatureFileFillElement = ({ element }) => {
  return (
    <Box display="flex" width="100%" alignItems="center">
      <Grid container direction="column" spacing={2}>
        <Grid item xs={12}>
          {element.type !== "signature" && (
            <Typography variant="subtitle1" gutterBottom>
              {element.props.label}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12}>
          {element.type === "signature" &&
          element.props.signatureMode === "Type" ? (
            <Typography
              sx={{
                textAlign: {
                  xs: "center", // Center the label on small screens
                  sm: "left", // Align left on larger screens
                },
                fontSize: {
                  xs: "1rem", // Smaller font size on small screens
                  sm: "1.2rem", // Normal font size on medium screens
                },
              }}
            >
              {element.props.value}
            </Typography>
          ) : (
            //   <img
            //   src={element.props.value}
            //   alt={`Image ${element.type}`}
            //   style={{ width: '100%',  maxWidth: {
            //       xs: "100%",  // Full width on small screens
            //       sm: element.props.width, // Use provided width on larger screens
            //     }, height: "auto",  border: '1px solid #ccc', }}
            // />
            <Box
              component="img"
              src={element.props.value}
              alt={`Image ${element.type}`}
              sx={{
                width: element.type === "signature" ? "auto" : "100%", // Adjust width based on type
                maxWidth: {
                  xs: element.type === "signature" ? "150px" : "100%", // Button-like size for signature
                  sm:
                    element.type === "signature"
                      ? "200px" // Slightly larger on medium screens
                      : element.props.width, // Use provided width for other types
                },
                height: element.type === "signature" ? "auto" : "auto", // Maintain aspect ratio
                maxHeight:
                  element.type === "signature" ? "50px" : element.props.height, // Button height for signature
                border: "1px solid #ccc",
                padding: element.type === "signature" ? "8px" : 0, // Padding for button-like appearance
                display: element.type === "signature" ? "inline" : "block",
                margin: "0 auto", // Center the signature image
                cursor: element.type === "signature" ? "pointer" : "default", // Pointer cursor for signature
              }}
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
export default SignatureFileFillElement;
